export const AVAILABLE_ACTIONS_KEY = Symbol("client-cabinet:available-actions");
